import { AuthConsts } from "./Auth.consts";

let iframeWindow = null;
let childReady = false;

//  Keep ONLY latest navigation
let lastQueuedPath = null;

//  Track last sent navigation
let lastSentPath = null;

//  Helper — detect dashboard root
const isDashboardRoot = path => {
  if (!path) return false;
  return path === "/app/asm/dashboard/" || path === "/app/asm/dashboard";
};

//  Helper — detect deeper ASM route
const isDeeperAsmRoute = path => {
  if (!path) return false;
  return path.startsWith("/app/asm/dashboard") && path.split("/").length > 3;
};

export const registerIframeWindow = win => {
  iframeWindow = win;
  childReady = false;
};

export const markChildReady = () => {
  console.log("[PARENT] CHILD READY");

  childReady = true;

  if (lastQueuedPath) {
    console.log("[PARENT] 🚀 Flushing queued navigation:", lastQueuedPath);
    sendNavigate(lastQueuedPath);
    lastQueuedPath = null;
  }
};

export const navigateIframe = path => {
  if (!path || path === "/") {
    console.log("[PARENT] ❌ Ignoring empty/root navigation:", path);
    return;
  }

  // Always keep latest intent
  lastQueuedPath = path;

  if (!iframeWindow || !childReady) {
    console.log("[PARENT] ⏳ Queueing navigation:", path);
    return;
  }

  sendNavigate(path);
};

function sendNavigate(path) {
  if (!iframeWindow) return;

  console.log("[PARENT] NAVIGATE_TO:", path);

  lastSentPath = path;

  iframeWindow.postMessage(
    {
      source: AuthConsts.IFX_PORTAL,
      messageType: AuthConsts.NAVIGATE_TO,
      payload: {
        location: { pathname: path },
      },
    },
    "*"
  );
}

export const resetIframeNavigation = () => {
  console.log("[PARENT] 🔥 FULL iframe navigation reset");
  iframeWindow = null;
  childReady = false;
  lastQueuedPath = null;
  lastSentPath = null;
};
